/** @internal */
export const OP_DONE = "Done" as const

/** @internal */
export type OP_DONE = typeof OP_DONE

/** @internal */
export const OP_AWAIT = "Await" as const

/** @internal */
export type OP_AWAIT = typeof OP_AWAIT
